import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';

export function useGetSelectedSlideId(): string | undefined {
  const activeItemId = useSingleActivePosterItemId();

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId ?? ''];

    if (item?.gitype === ITEM_TYPE.SLIDESHOW) {
      const itemCopy = item as SlideshowItemObject;
      return itemCopy.selectedSlideUID;
    }

    return undefined;
  });
}
